import { withHydrate } from '@relay/react/hooks';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const GlobalCss = /*#__PURE__*/createGlobalStyle(["\n  .react-component--contents {\n      display: contents;\n  }\n\n\n  .product-page__padded-section {\n    background-color: ", ";\n    padding: 40px 0px;\n\n    @media ", " {\n      padding: 60px 0px;\n    }\n\n    @media ", " {\n      padding: 80px 0px;\n    }\n\n    @media ", " {\n      padding: 100px 0px;\n    }\n  }\n"], brand.grey['97'], from(Device.Tablet), from(Device.TabletLarge), from(Device.Desktop));
const GlobalStyles = () => /*#__PURE__*/_jsx(_Fragment, {
  children: /*#__PURE__*/_jsx(GlobalCss, {})
});
export default withHydrate(GlobalStyles, 'GlobalStyles', 'hybrid');
